/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_WebsiteInputs */

const en_agent_authorization_field_website = /** @type {(inputs: Agent_Authorization_Field_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production website`)
};

const zh_agent_authorization_field_website = /** @type {(inputs: Agent_Authorization_Field_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产环境网站`)
};

/**
* | output |
* | --- |
* | "Production website" |
*
* @param {Agent_Authorization_Field_WebsiteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_website = /** @type {((inputs?: Agent_Authorization_Field_WebsiteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_WebsiteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_website(inputs)
	return zh_agent_authorization_field_website(inputs)
});
export { agent_authorization_field_website as "agent.authorization.field.website" }